import Dialog from 'components/general/dialogs/Dialog';
import { IMissionVersion } from 'components/general/types';
import { TEntityDialogControl } from 'hooks/EntityDialogControlHook';
import { useRef } from 'react';
import { ICommit } from '../useGitHistory';
import CommitRow from './CommitRow';
import useStyles from './styles';

interface IProps {
  dialogControl: TEntityDialogControl<IMissionVersion>;
  commitHist: ICommit[];
}

const HistoryDialog = (props: IProps) => {
  const { dialogControl, commitHist } = props;
  const { dialogConfig, closeDialog } = dialogControl;
  const { entity: branch } = dialogConfig;

  const ref = useRef<HTMLDivElement>(null);

  const passedMaxHeight = !!ref.current && ref.current.scrollHeight > ref.current.clientHeight;
  const { classes } = useStyles({ passedMaxHeight });

  return (
    <Dialog
      open={dialogConfig.open}
      onClose={closeDialog}
      title={`Commit History for ${dialogConfig.entity?.name}`}
      secondaryActionText="Close"
    >
      <div className={classes.fadeAndBorder}>
        <div className={classes.historyContainer} ref={ref}>
          {commitHist.map((commit) => {
            return (
              <CommitRow
                branch={branch as IMissionVersion}
                key={commit.hexsha}
                commit={commit}
                passedMaxHeight={passedMaxHeight}
                closeHistoryDialog={closeDialog}
              />
            );
          })}
          {passedMaxHeight && <div style={{ minHeight: 20 }} />}
        </div>
      </div>
    </Dialog>
  );
};

export default HistoryDialog;
